import script from "./home2.vue?vue&type=script&setup=true&lang=js"
export * from "./home2.vue?vue&type=script&setup=true&lang=js"

import "./home2.vue?vue&type=style&index=0&id=3c953844&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.13_webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c953844"]])

export default __exports__